import { Close } from "@mui/icons-material";
import Skeleton from "react-loading-skeleton";
import { Box } from "~/components/Box/Box";
import { TextButton } from "~/components/TextButton/TextButton";
import { Text } from "~/components/Text/Text";
import { TextField } from "~/components/TextField/TextField";
import styles from "./VoucherCodeInLine.module.scss";
import { Form } from "~/components/Form/Form";

export function VoucherCodeInLine({
  value,
  skeleton,
  show,
  onChange,
  onHide,
  onShow,
  onSubmit,
}: {
  value: string;
  show: boolean;
  skeleton: boolean;
  onShow: () => void;
  onHide: () => void;
  onSubmit: () => void;
  onChange: (value: string) => void;
}) {
  return (
    <Box display={"flex"} flexDirection={"column"}>
      <Box
        width="full"
        alignItems="center"
        display="flex"
        justifyContent="flexEnd"
      >
        {skeleton ? (
          <Skeleton width={110} style={{ flex: 1 }} />
        ) : (
          <div style={{ display: show ? "none" : "flex" }}>
            <TextButton onClick={onShow}>ENTER PROMO CODE</TextButton>
          </div>
        )}
      </Box>
      <Box
        className={show ? styles.open : styles.closed}
        background="jets-beige"
        borderRadius="standard"
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"spaceBetween"}
          width="full"
          padding={"2"}
        >
          <Text font="accent" size="large" weight="strong" color="jets-black">
            {"Promo Code"}
          </Text>
          <Box cursor="pointer" onClick={onHide}>
            <Close
              htmlColor={"var(--color-over-primary)"}
              style={{
                fontWeight: 900,
                fontSize: 24,
                color: "var(--color-jets-black)",
              }}
            />
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"row"} paddingX={"3"}>
          <Box flexGrow={1}>
            <Form onSubmit={onSubmit}>
              <TextField value={value} onChange={onChange} />
            </Form>
          </Box>
          <Box
            marginLeft={"2"}
            paddingX={"3"}
            onClick={onSubmit}
            style={{
              display: "flex",
              borderRadius: 5,
              fontFamily: "var(--font-special)",
              fontSize: 18,
              backgroundColor: "var(--color-jets-beige)",
              border: "1px solid var(--color-jets-black)",
              color: "var(--color-jets-black)",
              fontWeight: 800,
              cursor: "pointer",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            APPLY
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
